import React, { useState } from "react";
import Box from "@mui/material/Box";
import UserLayout from "../../../user";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { Avatar, Button, Table, TableBody, TableCell, TableRow } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router";
import PDF from "../../../../assets/images/pdf.png";
import word from "../../../../assets/images/word.png";
import CSV from "../../../../assets/images/csv.png";
import AppointmentReschedule from "../../../../components/card-appointment/AppointmentReschedule";
import AppointmentSchedule from "../../../../components/card-appointment/AppointmentSchedule";
import {AppointmentAllStatusArray} from "../../../../services/utills";
import {content, heading, wallet} from "../../../../components/card-appointment/CardAppointment";
import { useDispatch, useSelector } from "react-redux";
import UserInvoices from "../../../user/user-bookings/user-invoices/userInvoices";
import { storeUserInvoice } from "../../../../store/booking-widget";
import NOShowmodal from "../../../../components/modal/NoShowmodal";

const ExpandableNote = ({ children }) => {
  const [expanded, setExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const textRef = React.useRef(null);

  React.useEffect(() => {
    const el = textRef.current;
    if (el && !expanded) setIsClamped(el.scrollHeight > el.clientHeight + 1);
  }, [children, expanded]);

  return (
    <Box>
      <Typography
        ref={textRef}
        variant="body2"
        sx={{
          color: '#000',
          wordBreak: 'break-word',
          ...(!expanded && {
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }),
        }}
      >
        {children}
      </Typography>
      {(isClamped || expanded) && (
        <Typography
          component="span"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{ fontSize: '12px', fontWeight: 600, color: '#8B1A4A', cursor: 'pointer' }}
        >
          {expanded ? 'Hide' : 'See more'}
        </Typography>
      )}
    </Box>
  );
};

const AppointmentDetailscalender = ({ appointmentDetails, onInvoiceClick }) => {
//console.log("appointment data",appointmentDetails?.appointments?.data)
  const navigate = useNavigate()
    const dispatch = useDispatch();
    const authStore = useSelector((state) => state?.authStore);
      const { user } = authStore;
       const bookingWidgetStore = useSelector((state) => state?.bookingWidgetStore);
        const {
          userInvoice,
          userBookings, 
          userBookingStatus,
          filterBy,
          pageLimit,                        
          currentPage,
          search,
        } = bookingWidgetStore;
 const handleAppointmentClick = (url) => {
  navigate(url, {
    state: { from: location.pathname }
  });
};
      const [isExpanded, setIsExpanded] = useState(false);

    // Determine the number of services to display based on isExpanded
    const displayedServices = isExpanded ? appointmentDetails?.services : appointmentDetails?.services?.slice(0, 1);

    const handleToggle = () => {
        setIsExpanded(prevState => !prevState);
    };

    // This card also renders inside narrow side panels (e.g. the calendar's
    // appointment detail), where the viewport is wide but the container is not,
    // so `sm={4}` would keep three columns crammed into ~400px. Stack them off
    // the container's own width instead; full-width usages are unaffected.
    const stackWhenNarrow = {
      '@container (max-width: 640px)': {
        flexBasis: '100%',
        maxWidth: '100%',
        borderRight: 'none',
        borderBottom: '1px solid #EBEBEB',
      },
    };
    const stackWhenNarrowLast = {
      '@container (max-width: 640px)': {
        flexBasis: '100%',
        maxWidth: '100%',
        borderRight: 'none',
      },
    };

  return (
    <Box sx={{ background: "#F1F5F9" }}>
      {appointmentDetails?.plan?.id &&
        <Grid
          item
          xs={12}
          sx={{
            background: '#fff',
            borderRadius: '10px',
            border: '1px solid #EBEBEB',
            p: '24px',
            mb: '14px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <Box
            sx={{
              display: "flex", 
              justifyContent: 'space-between',
            }}
          >
            <Box>   
              <Typography   
                variant="body2"
                color="initial"
                sx={{ color: "#1a1a2e", fontSize: '14px', fontFamily: 'helvetica-lt-std-bold', fontWeight: 700, pb: '8px', borderBottom: '1px solid #F1F5F9', mb: '12px' }}
              >
                Bundle Details:
              </Typography>
              {appointmentDetails?.is_plan=== 0 ?(
 <Box sx={{ display: "flex", mt: 2 }}>
 <Typography
   variant="body2"
   color="initial"
   sx={{ 
     minWidth: '100px',
     fontSize: '16px',
     fontFamily: 'helvetica-lt-std-bold',
   }}
 >
   Bundle Name:
 </Typography>
 <Typography variant="body2" color="initial" sx={{
   ml: 1,
   fontSize: '16px',
   fontFamily: 'helvetica-lt-std-bold',
 }}>
   {appointmentDetails?.plan?.title}
 </Typography>
</Box>
              ):( <Box sx={{ display: "flex", mt: 2 }}>
              <Typography
                variant="body2"
                color="initial"
                sx={{
                  minWidth: '100px',
                  fontSize: '16px',
                  fontFamily: 'helvetica-lt-std-bold',
                }}
              >
                Session No:
              </Typography>
              <Typography variant="body2" color="initial" sx={{
                ml: 1,
                fontSize: '16px',
                fontFamily: 'helvetica-lt-std-bold',
              }}>
                {appointmentDetails?.current_session}
              </Typography>
             </Box>) }


             

              {/* appointmentDetails.current_session */}
              <Box sx={{ display: "flex", mt: 1 }}>
                <Typography
                  variant="body2"
                  color="initial"
                  sx={{
                    minWidth: '100px',
                    fontSize: '16px',
                    fontFamily: 'helvetica-lt-std-bold',
                  }}
                > 
                  Completed Session:
                </Typography>
                <Typography variant="body2" color="initial" sx={{
                  ml: 1,
                  fontSize: '16px',
                  fontFamily: 'helvetica-lt-std-bold',
                }}>
                  {appointmentDetails?.completed_session || 0} / {appointmentDetails?.plan?.no_of_bookings}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: '24px',
            }}
          >
            <Grid item lg={3.5} sm={3.5} xs={12}>
              <Box>
                <Typography
                  variant="body2"
                  color="initial"
                  sx={{ color: "#1a1a2e", fontSize: '14px', fontFamily: 'helvetica-lt-std-bold', fontWeight: 700, pb: '8px', borderBottom: '1px solid #F1F5F9', mb: '12px' }}
                >
                  Bundle Total Amount:
                </Typography>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Typography variant="body2" color="initial" sx={{ ml: 1 }}>
                    ${appointmentDetails?.plan_total_amount}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={3.5} sm={3.5} xs={12} >
              <Box>
                <Typography
                  variant="body2"
                  color="initial"
                  sx={{ color: "#1a1a2e", fontSize: '14px', fontFamily: 'helvetica-lt-std-bold', fontWeight: 700, pb: '8px', borderBottom: '1px solid #F1F5F9', mb: '12px' }}
                >
                  Received Amount:
                </Typography>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Typography variant="body2" color="initial" sx={{ ml: 1 }}>
                    ${appointmentDetails?.plan_received_amount}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item lg={3.5} sm={3.5} xs={12}>
              <Box>
                <Typography
                  variant="body2"
                  color="initial"
                  sx={{ color: "#1a1a2e", fontSize: '14px', fontFamily: 'helvetica-lt-std-bold', fontWeight: 700, pb: '8px', borderBottom: '1px solid #F1F5F9', mb: '12px' }}
                >
                  Remaining Amount:
                </Typography>
                <Box sx={{ display: "flex", mt: 2 }}>
                  <Typography variant="body2" color="initial" sx={{ ml: 1 }}>
                    ${appointmentDetails?.plan_remaining_amount}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <TableContainer
            component={Paper}
            sx={{
              mt: "24px",
              overflowX: 'auto',
              maxWidth: '100%',
            }}
          >
            <Table sx={{ minWidth: { xs: 'auto', sm: 650 } }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow sx={{ background: '#FAFAFA' }}>
                  {['Session No','Status','Date & Time','Booking Ref'].map((h) => (
                    <TableCell key={h} sx={{ fontSize: '12px', fontWeight: 700, color: '#9AA0AC', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {appointmentDetails?.related_appointments?.length > 0 &&
                  appointmentDetails?.related_appointments.map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell scope="row">
                        <Box
                          sx={{
                            width: "max-content",
                            borderRadius: "8px",
                            p: '5px 10px',
                            border: `1px solid ${row?.status_color || 'black'}`,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            navigate(`/crm/appointment/details/${row?.id}`)
                          }}
                        >
                          <Typography
                            sx={{

                              color: row?.status_color || 'black',
                            }}
                          >
                            Session No {row.current_session}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell > 
                        <Typography
                          sx={{
                            background: row?.status_color,
                            p: '2px 22px',
                            borderRadius: '13px',
                            color: '#fff',
                            ml: 1,
                            width:'130px',
                            // minWidth:'50px'
                          }}
                        >
                          {row.status}
                        </Typography>
                      </TableCell>
                      <TableCell >
                        <Typography
                          sx={{
                            color: row.date ? '#000' : '#F25022',
                          }}
                        >
                          {row.date ? moment(row.date).format('MMMM DD, YYYY') :
                              <Grid item lg={10} xl={8} sm={10} md={10} xs={12}>
                                <AppointmentSchedule fwidth={'100%'} appointment={row} buttonText="Book Now" />
                              </Grid>
                          }
                        </Typography>
                        <Typography>
                          {row.date ? row.start_time + " - " + row.end_time : ''}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            width: "max-content",
                            borderRadius: "8px",
                            p: '5px 10px',
                            border: `1px solid ${row?.status_color || 'black'}`,
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            navigate(`/crm/appointment/details/${row?.id}`)
                          }}
                        >
                          <Typography
                            sx={{
                              color: row?.status_color || 'black',
                            }}
                          >
                            Booking Ref {row?.id}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      }
      <UserLayout pb="6px">


        {/* ── Main detail card ── */}
        <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>

          {/* Row 1 — 3 columns */}
          <Grid container sx={{ borderBottom: '1px solid #EBEBEB', containerType: 'inline-size' }}>

            {/* Appointment Date */}
            <Grid item xs={12} sm={4} sx={{ p: '20px 24px', borderRight: { sm: '1px solid #EBEBEB', xs: 'none' }, ...stackWhenNarrow }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', mb: '10px', fontFamily: 'helvetica-lt-std-bold' }}>
                Appointment Date
              </Typography>
              <Typography sx={{ fontSize: { sm: '20px', xs: '17px' }, fontFamily: 'helvetica-lt-std-bold', fontWeight: 800, color: appointmentDetails.date ? '#000' : '#F25022', lineHeight: 1.3 }}>
                {appointmentDetails?.date ? moment(appointmentDetails?.date).format('dddd MMMM D, YYYY') : 'Date and Time Not Set'}
              </Typography>
              {appointmentDetails?.date && (
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', mt: '6px' }}>
                  {appointmentDetails?.start_time} – {appointmentDetails?.end_time}
                </Typography>
              )}
            </Grid>

            {/* Booking Details */}
            <Grid item xs={12} sm={4} sx={{ p: '20px 24px', borderRight: { sm: '1px solid #EBEBEB', xs: 'none' }, display: { xs: 'none', sm: 'block' }, ...stackWhenNarrow }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', mb: '12px', fontFamily: 'helvetica-lt-std-bold' }}>
                Booking Details
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Booking ID</Typography>
                <Typography
                  sx={{ fontSize: '13px', fontWeight: 700, color: user?.role_id === 3 ? '#000' : '#2F80ED', cursor: user?.role_id === 3 ? 'default' : 'pointer' }}
                  onClick={user?.role_id === 3 ? undefined : () => handleAppointmentClick(`/crm/appointment/details/${appointmentDetails?.id}`)}
                >
                  #{appointmentDetails?.id}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}
                onClick={async () => {
                  if (user?.role_id === 3) { await dispatch(storeUserInvoice(appointmentDetails)); navigate('/user/appointment/invoice'); }
                  else if (typeof onInvoiceClick === 'function') { onInvoiceClick(appointmentDetails?.id); }
                  else { handleAppointmentClick(`/crm/invoices/${appointmentDetails?.id}`, { state: { from: location.pathname } }); }
                }}
                style={{ cursor: 'pointer' }}
              >
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Invoice ID</Typography>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: appointmentDetails?.invoices?.invoices_methods?.[0]?.id ? '#2F80ED' : '#000' }}>
                  {appointmentDetails?.invoices?.invoices_methods?.[0]?.id ?? 'N/A'}
                </Typography>
              </Box>
              {appointmentDetails?.plan?.id && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '8px' }}>
                  <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Booking Status</Typography>
                  <Typography sx={{ display: 'inline-flex', background: appointmentDetails?.status_color, px: '12px', py: '2px', borderRadius: '20px', color: '#fff', fontSize: '12px', fontWeight: 700 }}>
                    {appointmentDetails?.status === 'NoShow' ? 'No Show' : appointmentDetails?.status}
                  </Typography>
                </Box>
              )}
            </Grid>

            {/* Payment Details */}
            <Grid item xs={12} sm={4} sx={{ p: '20px 24px', ...stackWhenNarrowLast }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', mb: '12px', fontFamily: 'helvetica-lt-std-bold' }}>
                Payment Details
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Payment Status</Typography>
                <Typography sx={{ display: 'inline-flex', background: appointmentDetails?.payment_status === 'Paid' || appointmentDetails?.payment_status === 'Pre Paid' ? '#1C7E46' : '#C64949', px: '12px', py: '2px', borderRadius: '20px', color: '#fff', fontSize: '12px', fontWeight: 700 }}>
                  {appointmentDetails?.payment_status}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Grand Total</Typography>
                <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#000' }}>${appointmentDetails?.grand_total}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px'}}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Booking Status</Typography>
                <Typography sx={{ display: 'inline-flex', background: appointmentDetails?.status_color, px: '12px', py: '2px', borderRadius: '20px', color: '#fff', fontSize: '12px', fontWeight: 700 }}>
                  {appointmentDetails?.status === 'NoShow' ? 'No Show' : appointmentDetails?.status}
                </Typography>
              </Box>
              {appointmentDetails?.status === 'No Show' && <Box sx={{ mt: '6px' }}><NOShowmodal Data={appointmentDetails} /></Box>}
              {appointmentDetails?.plan?.id && (
                <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', mt: 1, border: `1.5px solid ${appointmentDetails?.status_color || '#ccc'}`, borderRadius: '8px', px: '14px', py: '4px' }}>
                  <Typography sx={{ fontSize: '11px', color: appointmentDetails?.status_color || '#333', fontWeight: 600 }}>Session No</Typography>
                  <Typography sx={{ fontSize: '18px', fontWeight: 800, color: appointmentDetails?.status_color || '#333' }}>{appointmentDetails.current_session}</Typography>
                </Box>
              )}
            </Grid>
          </Grid>

          {/* Row 2 — Services */}
          {displayedServices?.length > 0 && (
            <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
              {!appointmentDetails?.plan?.id && (
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold', mb: '10px' }}>
                  Services Details
                </Typography>
              )}
              {displayedServices.map((service, servicesKey) => (
                appointmentDetails?.is_plan === 0 && (
                  <Box key={servicesKey} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '8px', borderBottom: servicesKey < displayedServices.length - 1 ? '1px solid #F5F5F5' : 'none' }}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#000', flex: 1 }}>
                      {service?.name}
                      {appointmentDetails?.type === 'Consultation' ? ' (In Person Consultation)' : appointmentDetails?.type === 'Virtual Consultation' ? ' (Virtual)' : ''}
                    </Typography>
                    <Typography sx={{ fontSize: '13px', color: '#333', mx: 2 }}>{service?.service_quantity}</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {service?.extra_quantity !== null && (
                        <Typography sx={{ fontSize: '12px', color: '#555' }}>Extra Qty({service?.extra_quantity})</Typography>
                      )}
                      <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#000' }}>${service?.booking_cost}</Typography>
                    </Box>
                  </Box>
                )
              ))}
              {appointmentDetails?.services?.length > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: '8px' }}>
                  <Button onClick={handleToggle} variant="text" sx={{ textTransform: 'none', fontWeight: 700, fontSize: '13px' }}>
                    {isExpanded ? 'Show Less' : 'Show More...'}
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Box>
        {/* ── Payment Breakdown card ── */}
        <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
          <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>
              Payment Detail
            </Typography>
          </Box>
          <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
            {appointmentDetails.type === "Consultation" && (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Deposit Amount</Typography>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  {appointmentDetails?.upfront_amount !== undefined ? `$${appointmentDetails?.upfront_amount}` : "$0"}
                </Typography>
              </Box>
            )}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Sub Total</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.services_total_cost !== undefined ? `$${appointmentDetails?.services_total_cost}` : "$0"}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Discount</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.invoices?.discount && parseFloat(appointmentDetails?.invoices?.discount) > 0
                  ? `-$${appointmentDetails?.invoices?.discount}` : "$0"}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Amount</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.invoices?.amount_after_add_discount !== undefined ? `$${appointmentDetails?.invoices?.amount_after_add_discount}` : "$0"}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Tax</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.invoices?.tax !== undefined ? `$${appointmentDetails?.invoices?.tax}` : "$0"}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #EBEBEB' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Tip</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.invoices?.tip !== undefined ? `$${appointmentDetails?.invoices?.tip}` : "$0"}
              </Typography>
            </Box>
            {/* Grand Total */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '10px', borderBottom: '1px solid #EBEBEB' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Grand Total</Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>
                {appointmentDetails?.invoices?.amount_after_tip_and_tax !== undefined
                  ? `$${Number(appointmentDetails.invoices.amount_after_tip_and_tax).toFixed(2)}` : "$0"}
              </Typography>
            </Box>
            {/* Payment methods */}
            {appointmentDetails?.invoices?.invoices_methods?.map((method, i) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }} key={i}>
                <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>{method?.payment_methods}</Typography>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                  {method?.payment_methods !== 'Future Payment' && "-"} ${method?.amount}
                </Typography>
              </Box>
            ))}
            {/* Due Amount */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: '10px' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Due Amount</Typography>
              <Typography sx={{ fontSize: '15px', fontWeight: 800, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>
                {appointmentDetails?.due_amount !== undefined ? `$${appointmentDetails?.due_amount}` : "$0"}
              </Typography>
            </Box>
          </Box>
        </Box>
        {appointmentDetails?.role_id !== 3 && (
          <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
            <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Notes</Typography>
            </Box>
            <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
              <Box sx={{ py: '8px', borderBottom: '1px solid #F5F5F5' }}>
                <Typography sx={{ fontSize: '12px', color: '#333', fontWeight: 600, mb: '6px' }}>Customer Notes</Typography>
                {appointmentDetails?.appointment_customer_note && typeof appointmentDetails.appointment_customer_note === 'object' && appointmentDetails.appointment_customer_note !== null ? (
                  <Typography variant="body2" sx={{ color: '#000' }}>
                    <span style={{ fontFamily: 'helvetica-lt-std-bold' }}>
                      [{moment(appointmentDetails.appointment_customer_note?.staff?.created_at).format('h:mm A')}, {moment(appointmentDetails.appointment_customer_note?.staff?.created_at).format('YYYY-MM-D')}] {appointmentDetails.appointment_customer_note?.staff?.name}:
                    </span> {appointmentDetails.appointment_customer_note.description}
                  </Typography>
                ) : (
                  <Typography variant="body2" sx={{ color: '#555' }}>None</Typography>
                )}
              </Box>
              <Box sx={{ py: '8px' }}>
                <Typography sx={{ fontSize: '12px', color: '#333', fontWeight: 600, mb: '6px' }}>Medical / Staff Notes</Typography>
                {appointmentDetails?.notes?.Medical?.length > 0 ?
                  appointmentDetails?.notes?.Medical.map((medical, medicalIndex) => (
                    <Box key={medicalIndex}>
                      <ExpandableNote>
                        <span style={{ fontFamily: 'helvetica-lt-std-bold' }}>
                          [{moment(medical?.created_at).format("D MMM, YYYY")} ({moment(medical?.created_at).format("hh:mm A")})] {medical?.staff?.name}:
                        </span> {medical?.description}
                      </ExpandableNote>
                    </Box>
                  ))
                  : <Typography variant="body2" sx={{ color: '#555' }}>None</Typography>
                }
              </Box>
            </Box>
          </Box>
        )}

        {/* ── Attachments card ── */}
        <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
          <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Attachments</Typography>
          </Box>
          <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
            {appointmentDetails?.attachments?.length > 0 ?
              appointmentDetails?.attachments.map((attachment, attactmentIndex) => (
                <Box sx={{ display: 'flex', gap: '16px', flexWrap: { sm: 'nowrap', xs: 'wrap', lg: 'wrap', md: 'wrap' }, mb: '12px' }} key={attactmentIndex}>
                  <Box sx={{ display: 'flex', flexWrap: { sm: 'nowrap', xs: 'wrap', lg: 'wrap', md: 'wrap' } }}>
                    {attachment?.files?.length && attachment?.files?.map((file, fileIndex) => (
                      <Avatar
                        key={fileIndex}
                        src={file?.type === 'pdf' && PDF || file?.type === 'word' && word || file?.type === 'csv' && CSV || file?.file}
                        onClick={() => window.open(file?.file, '_blank')}
                        sx={{ cursor: 'pointer', height: '180px', width: '180px', border: '1px solid #E8E8E8' }}
                        variant="rounded"
                      />
                    ))}
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#555', mb: '6px' }}>
                      <i>{moment(attachment?.created_at)?.format('YYYY-MM-DD hh:mm A')}</i>
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: '#000' }}>Comments:</Typography>
                      <Typography variant="body2" sx={{ color: '#333' }}>{attachment?.comment}</Typography>
                    </Box>
                  </Box>
                </Box>
              ))
              : <Typography variant="body2" sx={{ color: '#555' }}>None</Typography>
            }
          </Box>
        </Box>
        {/* ── Staff & Clinic card ── */}
        <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
          <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Staff & Clinic</Typography>
          </Box>
          <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5', gap: 1 }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Assigned Staff Member</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', textTransform: 'capitalize', wordBreak: 'break-word', textAlign: { xs: 'left', sm: 'right' } }}>
                {appointmentDetails?.staff?.id ? appointmentDetails?.staff?.name : 'Not Assigned'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5', gap: 1 }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Default Clinic</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', wordBreak: 'break-word', textAlign: { xs: 'left', sm: 'right' } }}>{appointmentDetails?.provider?.name}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', py: '6px', gap: 1 }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Booking Clinic</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', wordBreak: 'break-word', textAlign: { xs: 'left', sm: 'right' } }}>{appointmentDetails?.reference_clinic_name}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Mobile-only Booking Details */}
        <Box sx={{ display: { sm: 'none', xs: 'block' }, background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
          <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Booking Details</Typography>
          </Box>
          <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
            <Box
              sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5', cursor: user?.role_id === 3 ? 'default' : 'pointer' }}
              onClick={user?.role_id === 3 ? undefined : () => handleAppointmentClick(`/crm/appointment/details/${appointmentDetails?.id}`)}
            >
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Booking ID</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: user?.role_id === 3 ? '#000' : '#2F80ED' }}>#{appointmentDetails?.id}</Typography>
            </Box>
            <Box
              sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', cursor: 'pointer' }}
              onClick={async () => {
                if (user?.role_id === 3) { await dispatch(storeUserInvoice(appointmentDetails)); navigate('/user/appointment/invoice'); }
                else if (typeof onInvoiceClick === 'function') { onInvoiceClick(appointmentDetails?.id); }
                else { handleAppointmentClick(`/crm/invoices/${appointmentDetails?.id}`, { state: { from: location.pathname } }); }
              }}
            >
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Invoice ID</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: appointmentDetails?.invoices?.invoices_methods?.[0]?.id ? '#2F80ED' : '#000' }}>
                {appointmentDetails?.invoices?.invoices_methods?.[0]?.id ?? 'N/A'}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Record Info card ── */}
        <Box sx={{ background: '#fff', borderRadius: '10px', border: '1px solid #EBEBEB', overflow: 'hidden', mb: '14px' }}>
          <Box sx={{ p: { xs: '12px 14px', sm: '14px 24px' }, borderBottom: '1px solid #EBEBEB' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000', fontFamily: 'helvetica-lt-std-bold' }}>Record Info</Typography>
          </Box>
          <Box sx={{ p: { xs: '12px 14px', sm: '16px 24px' } }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Created On</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {moment(appointmentDetails?.created_at).format("D MMM, YYYY")} ({moment(appointmentDetails?.created_at).format("hh:mm A")})
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px', borderBottom: '1px solid #F5F5F5' }}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Created By</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>{appointmentDetails?.created_by}</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between', alignItems: 'center', py: '6px'}}>
              <Typography sx={{ fontSize: '13px', color: '#333', fontWeight: 500 }}>Transaction ID</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#000' }}>
                {appointmentDetails?.invoices?.transaction_id ? appointmentDetails.invoices.transaction_id : 'N/A'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </UserLayout>
    </Box>
  );
};

export default AppointmentDetailscalender;
